<template>
  <footer class="footer-container">
    <div class="footer-content">
      <!-- 备案信息 -->
      <div class="footer-item" v-if="icpNumber">
        <a :href="`https://beian.miit.gov.cn/`" target="_blank">{{ icpNumber }}</a>
      </div>

      <!-- 版权信息 -->
      <div class="footer-item">
        &copy; {{ new Date().getFullYear() }} Cola. 保留所有权利
      </div>

      <!-- 当前时间 -->
      <div class="footer-item">
        {{ currentTime }}
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterBar',
  data() {
    return {
      icpNumber: '豫ICP备18036145号-1',
      currentTime: this.getCurrentTime(),
      timer: null
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.currentTime = this.getCurrentTime()
    }, 1000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    getCurrentTime() {
      const now = new Date()
      return now.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      })
    }
  }
}
</script>

<style scoped>
.footer-container {
  background-color: #f5f5f5;
  padding: 10px 0;
  text-align: center;
  border-top: 1px solid #eaeaea;
  font-size: 12px;
  color: #666;
  min-height: 30px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.footer-item {
  line-height: 1.2;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
    gap: 5px;
  }
  .footer-item {
    white-space: normal;
  }
}
</style>
